@include host-component-properties;

:host {
  --paf-result-footpath-background-color: var(--paf-global-post-brand-light);
  --paf-result-footpath-text-color: var(--paf-global-post-brand-black);
  --paf-result-footpath-icon-size: 16;
  --paf-result-footpath-font-size: 16;
  --paf-result-footpath-wheelchair-icon-size: 24;
  --paf-result-footpath-column-gap: var(--paf-global-spacing-fixed-3x);
  --paf-result-footpath-text-padding-inline: var(--paf-global-spacing-fixed-2x);
}

.footpath {
  @include level2-grid;

  --paf-level2-grid-padding-block: var(--paf-global-spacing-fixed-2x);

  @include mq($from: small) {
    --paf-level2-grid-column-1-width: 92;
  }

  @include mq($from: medium) {
    --paf-level2-grid-column-1-width: 100;
  }

  align-items: center;
  column-gap: px-to-rem(var(--paf-result-footpath-column-gap));
  font-size: px-to-rem(var(--paf-result-footpath-font-size));
  color: var(--paf-result-footpath-text-color);
  background-color: var(--paf-result-footpath-background-color);
  min-height: px-to-rem(var(--paf-global-spacing-fixed-10x));

  .time {
    font-size: inherit;
    text-align: right;
    padding-inline-start: px-to-rem(var(--paf-result-footpath-text-padding-inline));

    .time-hidden-text {
      @include screen-reader-only;
    }
  }

  .icon {
    height: px-to-rem(var(--paf-result-footpath-icon-size));
    fill: currentcolor;
  }

  .icon--wheelchair {
    height: px-to-rem(var(--paf-result-footpath-wheelchair-icon-size));
    width: px-to-rem(var(--paf-result-footpath-wheelchair-icon-size));
    margin-block-start: px-to-rem(-3);
    margin-block-end: px-to-rem(-2);
  }

  .description {
    font-size: inherit;
    padding-inline-end: px-to-rem(var(--paf-result-footpath-text-padding-inline));
  }
}
